import template from '@stackhouse/dashboard-components/utils/template'

import AttachmentFromFile from '../modals/attachmentFromFile'

import Toast from '@stackhouse/dashboard-components/Toast'

const DefaultAttachmentActions = ({ deleteEndpoint = '/attachment/{{idnrr}}' } = {}) => [
    {
        id: 'newDirect',
        title: 'New (file)',
        icon: 'up_file',
        container: 'grid',
        onClick: function () {
            const { formName, resourceId } = this.props
            return AttachmentFromFile({ formName, resourceId, onSuccess: () => this.loadData() })
        }
    },
    {
        id: 'deleteAttachment',
        title: 'Delete',
        icon: 'delete_forever',
        container: 'grid',
        active: function () {
            return this.getSelectedRow()
        },
        onClick: function () {
            const { rows } = this.state
            const selectedRow = this.getSelectedRow()

            if (selectedRow) {
                const { rowIndex, row } = selectedRow
                const { client, withLoader } = this.props

                return withLoader(done => {
                    return client.delete(template(deleteEndpoint, row)).then(() => {
                        this.selectedRow = null
                        setTimeout(Toast.toast({
                            type: 'success',
                            showCloseButton: false,
                            text: 'Deleted.'
                        }), 3000)

                        return this.setState({ rows: [...rows.slice(0, rowIndex), ...rows.slice(rowIndex + 1)] })
                    }).then(done).catch(done)
                })
            }
        },
    },
]


export default DefaultAttachmentActions